import type { IEventFormData } from '../components/forms/EventForm';
import { rosterPeopleFrom } from '../components/AssignmentDrawer';

/**
 * Seed `EventForm` from an event row.
 *
 * `EventForm` submits every field it holds, so any field a caller forgets to
 * seed here is written back as empty on the next save. That is how the calendar
 * and invitations modals silently cleared `event_memberships` (the membership
 * coverage links) and, on the notification deep-link path, `activity_id` /
 * `course_id` / `season_id`. Keep this the single mapper: a new EventForm field
 * belongs here, not in a caller.
 */
export const eventToFormInitialData = (event: any): Partial<IEventFormData> => ({
  name: event.name,
  description: event.description,
  location: event.location || '',
  startTime: event.startTime,
  endTime: event.endTime,
  members: (event.members || []).map((m: any) => (typeof m === 'object' ? m._id : m)),
  rosterPeople: rosterPeopleFrom(event.members),
  groups: (event.groups || []).map((g: any) => (typeof g === 'object' ? g._id : g)),
  coveredByMembershipIds: event.coveredByMembershipIds ?? [],
  activityId: event.activityId ?? null,
  courseId: event.courseId ?? null,
  defaultAttendance: event.defaultAttendance ?? null,
  // `responsibleId` is the canonical column; `responsible` is the expanded
  // object some endpoints add. EventForm's select needs a string either way.
  responsible:
    event.responsibleId != null
      ? String(event.responsibleId)
      : typeof event.responsible === 'string'
        ? event.responsible
        : event.responsible?._id != null
          ? String(event.responsible._id)
          : '',
  price: event.price || 0,
  isOpen: event.isOpen || false,
  capacity: event.capacity || undefined,
  publicSlug: event.publicSlug || '',
  private: event.private || false,
  extendedDescription: event.extendedDescription || '',
  gallery: event.gallery || [],
  colorSettings: event.colorSettings || undefined,
});
